const STORAGE_KEY = "thrive_persistent_state";

export const getStoredState = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return "";
  }
};

export const storeState = state =>
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));

export const clearState = () => localStorage.removeItem(STORAGE_KEY);



// WEBPACK FOOTER //
// ./src/utilities/LocalStorage.js